import React from "react";
import { Container } from "react-bootstrap";
import Banner from "../../../Components/Banner";
import SubmitRFP from "../../../Components/SubmitRFP";
import { PRIVACY_BY_DESIGN_CONSULTATION } from "../../../services/Url";
import { useCustomGet } from "../../../services/Service";
import { TestimonialV2 } from "../../../Components/TestimonialV2";
import { Loader } from "../../../Components/Loader";
import ServiceSlider from "../../../Components/ServiceSlider";

const PrivacyByDesignConsultation = () => {
  const { data, isLoading } = useCustomGet(PRIVACY_BY_DESIGN_CONSULTATION);

  var bannerContent = {
    title: `<h1>${data?.pbds_banner_heading}</h1>`,
    cardTitle:data?.pbds_banner_sub_heading,
    cardPara:data?.pbds_banner_content,
  }

  return (
    <>
      {
        isLoading ? 
        <Loader /> :''
      }
      <Banner bannerCnt={bannerContent} banImg={data?.pbds_banner_image} />
      <section className=" bg-light service-trusted-by">
          <Container>
           <ServiceSlider />
           </Container>
        </section>
      <div className="internal-service-page" id="record-mang-service">
      
        <section
          className="award-sec sec-padding-top"
          style={{ backgroundColor: "#fff" }}
        >
          <Container>
            <h2 className="sec-heading">
              {data?.pbds_why_heading}
            </h2>
            <div className="complex-chng-des">
              <div className="cmpx-img-card mt-0 img_design">
                <img  loading="lazy"  width="" height=""   src={data?.pbds_why_image} alt="pbds_why_image" />
              </div>
              <div className="cmpx-chng-des ">
                <div className="ltd-case-description mt-md-4 mt-3">
                  <div className="custom-list"
                    dangerouslySetInnerHTML={{__html: data?.pbds_why_content}}
                  >             
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </section>
        <section
          className="award-sec sec-padding-top"
          style={{ backgroundColor: "#fff" }}
        >
          <Container>
            <h2 className="sec-heading">
              {data?.pbds_our_heading}
            </h2>
            <div className="complex-chng-des reverse">
              <div className="cmpx-chng-des ">               
                <div className="ltd-case-description mt-md-4 mt-3">
                  <div className="custom-list"
                    dangerouslySetInnerHTML={{__html: data?.pbds_our_content}}
                  >                   
                  </div>
                </div>
              </div>
              <div className="cmpx-img-card mt-0  img_design">
                <img  loading="lazy"  width="" height=""   src={data?.pbds_our_image} alt="pbds_our_image2" />
              </div>
            </div>
          </Container>
        </section>
        <section
          className="award-sec sec-padding"
          style={{ backgroundColor: "#fff" }}
        >
          <Container>
            <h2 className="sec-heading">
                {data?.pbds_what_heading}
            </h2>
            <div className="complex-chng-des">
              <div className="cmpx-img-card mt-0  img_design">
                <img  loading="lazy"  width="" height=""   src={data?.pbds_what_image} alt="pbds_what_image23" />
              </div>
              <div className="cmpx-chng-des custom-list "
                dangerouslySetInnerHTML={{__html: data?.pbds_what_content}}
              >
              </div>
            </div>
          </Container>
        </section>
        <section
          className="award-sec sec-padding-bottom"
          style={{ backgroundColor: "#fff" }}
        >
          <Container>
            <h2 className="sec-heading">
              {data?.pbds_benifit_heading}
            </h2>
            <div className="complex-chng-des reverse">
              <div className="cmpx-chng-des custom-list"
                dangerouslySetInnerHTML={{__html:data?.pbds_benifit_content}}
              >                               
              </div>
              <div className="cmpx-img-card mt-0  img_design">
                <img  loading="lazy"  width="" height=""   src={data?.pbds_benifit_image} alt="pbds_benifit_image" />
              </div>
            </div>
          </Container>
        </section>

        <section
          className="award-sec sec-padding-bottom"
          style={{ backgroundColor: "#fff" }}
        >
          <Container>
            <h2 className="sec-heading">
              {data?.pbds_why_wait_heading}
            </h2>
            <div className="complex-chng-des ">
            <div className="cmpx-img-card mt-0  img_design">
                <img  loading="lazy"  width="" height=""   src={data?.pbds_why_wait_image} alt="pbds_why_wait_image" />
              </div>
              <div className="cmpx-chng-des custom-list"
                dangerouslySetInnerHTML={{__html:data?.pbds_why_wait_content}}
              >                               
              </div>              
            </div>
          </Container>
        </section>
       <div className="bg-light">
       <TestimonialV2 />
       </div>
        <SubmitRFP />
      </div>
    </>
  );
};
export default PrivacyByDesignConsultation;
